import { render } from "./BumEffect.vue?vue&type=template&id=319f4382&scoped=true"
import script from "./BumEffect.vue?vue&type=script&lang=js"
export * from "./BumEffect.vue?vue&type=script&lang=js"

import "./BumEffect.vue?vue&type=style&index=0&id=319f4382&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319f4382"]])

export default __exports__